<template>
  <div class="goodsBox" style="display: flex;align-items: center;flex-wrap: wrap;">
    <div class="" v-for="(item,index) in list" :key="index" style="width: 226px;margin-right: 17px;margin-bottom: 30px;"
      @mouseenter="current1 = item" @mouseleave="current1 = 0" @click="goDetail(item)">
      <div class="" style="width: 226px;border-radius: 6px 6px 0 0;height: 127px;display: block;position: relative;">
        <img :src="baseUrl +item.cover_image" alt=""
          style="width: 226px;border-radius: 6px 6px 0 0;height: 127px;display: block;">
        <div class=""
          style="background-color: #fa3434;color: #fff;position: absolute;top: 10px;right: 10px;padding: 0 4px;font-size: 12px;">
          <img src="../assets/images/live.gif" alt="" style="height: 10px;width: 10px;">
          Live
        </div>
         <img src="../assets/imgs/play.png" alt=""
          style="height: 60px;width: 60px;position: absolute;top: 33px;left: 83px;" v-if="current1 == item">
        <div class=""
          style="position: absolute;top: 10px;left: 0;background-color: #218aff;color: #fff;padding: 0 3px;">
          推荐
        </div>
          <img :src="item.home_img" alt=""
          style="height: 40px;width: 40px;position: absolute;top: 50px;left: 20px;" v-if="item.types==3">
<img :src="item.away_img" alt=""
          style="height: 40px;width: 40px;position: absolute;top: 50px;right: 20px;" v-if="item.types==3">
      </div>
      <div class="" style="background-color: #fff;padding: 10px;border-radius: 0 0 6px 6px;">
        <div class="text-ellipsis" style=" ">
          {{ item.title }}
        </div>
        <div class="" style="display: flex;align-items: center;justify-content: space-between;margin-top: 5px;">
          <div class="" style="display: flex;align-items: center;font-size: 9px;color: #777;font-size: 12px;">
            <img :src="baseUrl+item.user.avatar" alt=""
              style="width: 20px;height: 20px;border-radius: 50%;margin-right: 4px;">
            {{ item.user.nickname }}
          </div>
          <div class="" style="display: flex;align-items: center;color: #777;font-size: 12px;">
            <img src="../assets/images/fire.png" alt="" style="width: 12px;height: 12px;margin-right: 2px;">
          {{ item.heat }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MyList",
  props: ["list", "isMore"],
  data() {
    return {
      current1: 0
    };
  },
  methods: {
    goDetail(item) {
       if (item.types == 3) {
        // 原始流
        this.$router.push({
          path: '/detailNew',
          query: {
            id: item.id
          }
        })
      } else {
        // 原始流
        this.$router.push({
          path: '/details',
          query: {
            id: item.id
          }
        })

      }

    },
  }
};
</script>
<style scoped>
.goodsBox div:nth-child(5n) {
  margin-right: 0 !important;
}
</style>